import { motion } from "framer-motion";
import { WhatsappIcon } from "@/components/BrandIcons";
import { waLink } from "@/lib/site";

const CHAT_MSG = "Hi Sunny Sir, I'm visiting the Goyal Academy website and would like to know more.";

export const WhatsAppFab = () => (
  <motion.a
    data-testid="whatsapp-fab"
    href={waLink(CHAT_MSG)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Sunny Sir on WhatsApp"
    initial={{ opacity: 0, scale: 0.6, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="group fixed bottom-24 right-4 z-[70] flex items-center gap-2 rounded-full bg-white p-1.5 pr-1.5 shadow-[0_18px_40px_-14px_rgba(37,211,102,0.75)] ring-1 ring-[#25D366]/30 lg:bottom-6 lg:right-6 lg:pr-4"
  >
    <span className="relative flex h-12 w-12 items-center justify-center">
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366]/30" />
      <WhatsappIcon className="relative h-12 w-12" />
    </span>
    <span className="hidden text-sm font-bold text-forest lg:block">Chat with Sunny Sir</span>
  </motion.a>
);
